import React from "react";
import { Helmet } from "react-helmet";
import { useGetTermsConditionQuery } from "../products/productSlice";

function TermsOfUse() {
  const { data, isLoading } = useGetTermsConditionQuery();
  console.log(data);
  return (
    <>
      <Helmet>
        <title>Terms & Condition | EHL Life Sciences Pvt Ltd</title>
        <meta name="keyword" content="EHL Life Sciences Pvt Ltd" />
        <meta name="description" content="EHL Life Sciences Pvt Ltd" />
      </Helmet>
      <section className="terms-of-use p-30">
        <div className="container">
          <div className="fisherman-content">
            <h3 className="heading">Terms And Conditions</h3>
            <p>
              These terms may be changed from time to time without further
              notice, at the discretion of the EHL Life Sciences Pvt Ltd. Your
              continued use of the Site ,ulafter any such changes constitutes
              your acceptance of the new terms. If you do not agree to abide by
              these or any future terms, please do not use the Site or download
              content from it.
            </p>
            <ul>
              <li>
                The Website and App provide you the ability to pay online
                through a third-party payment gateway for some of the Services
                available on the Website or App.If you choose to pay online, you
                may be directed to a third-party payment gateway to enable the
                processing of the payment. This transaction will be governed by
                the terms and conditions and privacy policy of the third-party
                payment gateway. EHL Life Sciences Pvt Ltd shall not be liable
                for any loss or damage arising directly or indirectly arising
                out of the usage, decline, or acceptance of authorization for
                any transaction, for any reason whatsoever.
              </li>
              <li>
                The cancellation and refund policy is only applicable to all
                online payments made through mobile apps and websites for
                booking appointments.
              </li>
              <li>
                In case a cancellation is initiated by the user, at the time of
                cancellation, the amount will be refunded via the same source of
                payment and will be subject to the payment terms of the source
                only. The amount will be refunded within 15 working days.
              </li>
              <li>
                Some of the content, text, data, graphics, images, information,
                suggestions, guidance and other material (collectively,
                “Information”) that may be available on the Website (including
                information provided in direct response to your questions or
                postings) may be provided by individuals in the medical
                profession. The provision of such Information does not create a
                licensed medical professional/patient relationship, between EHL
                Life Sciences Pvt Ltd and you and does not constitute an
                opinion, medical advice, or diagnosis or treatment of any
                particular condition, but is only provided to assist you with
                locating appropriate medical care from a qualified practitioner.
                In case of a medical emergency (either on your or another
                person’s behalf), please contact an ambulance service, hospital,
                doctor, or appropriate medical professional directly.
              </li>
              <li>
                By using this Website and App, you agree that any information
                shared by you with EHL Life Sciences Pvt Ltd or with any other
                person, medical service provider, or anyone else using the
                Website, App, or Services will be subject to our Privacy Policy.
              </li>
              <li>
                You are solely responsible for the content that you choose to
                submit for publication on the Website, including any feedback,
                ratings, or reviews. EHL Life Sciences Pvt Ltd disclaims all
                responsibility with respect to the content of which you post on
                the Website and EHL Life Sciences Pvt Ltd shall be entitled to
                re-publishing any content across any of its or its Partners
                platforms.{" "}
              </li>
              <li>
                You agree that EHL Life Sciences Pvt Ltd may contact you through
                telephone, email, SMS, or any other electronic means of
                communication for the purpose of obtaining feedback in relation
                to its Website, App, or services
              </li>
              <li>
                If a User has any questions concerning the Company, the Website
                or App, this Agreement, the Services, or anything related to any
                of the foregoing, please write to us at: info@sislifebiotech.org
              </li>
              <li>
                If User has any grievance with respect to the Website or App or
                the Service, including any discrepancies and grievances with
                respect to the processing of information, you can contact our
                Grievance Officer at: info@sislifebiotech.org
              </li>
              <li>
                Any appointment, health checkups, health schemes, diagnostic
                tests, a medical facility may terminate, change, suspend or
                discontinue at any time. EHL Life Sciences Pvt Ltd may remove,
                modify or otherwise change any content, including that of third
                parties, on or from this Site. EHL Life Sciences Pvt Ltd may
                impose limits on certain features and services or restrict your
                access to parts or the entire Site without notice or liability.
                EHL Life Sciences Pvt Ltd may terminate your use of the Site at
                any time at its sole discretion.
              </li>
              <li>
                These terms apply exclusively to your access to and use of the
                Website, App or services and do not alter the terms or
                conditions of any other agreement you may have with Sislife
                Biotech or its parents, subsidiaries or affiliates.{" "}
              </li>
            </ul>
          </div>

          <div className="fisherman-content">
            <h3 className="heading">DISCLAIMER</h3>
            <ul>
              <li>
                By accessing or browsing this website, you accept the terms and
                conditions herein without limitations or qualifications. Anybody
                using the website shall warrant to EHL Life Sciences Pvt Ltd
                that you will not use this website for any purpose that is
                unlawful, unethical in whatsoever manner.
              </li>
              <li>
                This Site (www.sislifebiotech.org) and the content available
                through it are provided on an “as is” and “as available” basis.
                You expressly agree that use of this Site and/or its content is
                at your sole risk.
              </li>
              <li>
                To the fullest extent permissible pursuant to applicable law,
                EHL Life Sciences Pvt Ltd and its affiliates disclaim all
                warranties of any kind, whether express or implied, including
                without limitation any warranty of merchantability, fitness for
                a particular purpose or non-infringement.
              </li>
              <li>
                You expressly agree that use of this Site, including all
                content, data or software distributed by, downloaded or accessed
                from or through the Site, is at your sole risk. You understand
                and agree that you will be solely responsible for any damage to
                your business, your computer system or loss of data that results
                from the download of such content, data and/or software.
              </li>
              <li>
                You acknowledge that EHL Life Sciences Pvt Ltd does not control
                information, products or services offered by third parties
                through the Site. Except as otherwise agreed in writing, Sislife
                Biotech and its affiliates assume no responsibility for and make
                no warranty or representation as to the accuracy, currency,
                completeness, reliability or usefulness of any advice, opinion,
                statement or other content or of any products or services
                distributed or made available by third parties through the Site.
              </li>
              <li>
                EHL Life Sciences Pvt Ltd does not make any warranty that this
                Site or its content will meet your requirements, or that this
                Site or its content will be uninterrupted, timely, secure, or
                error free, or that defects, if any, will be corrected. Nor does
                Sislife Biotech make any warranty as to the results that may be
                obtained from use of this Site or its content or as to the
                accuracy, completeness or reliability of any information
                obtained through use of this Site.
              </li>
              <li>
                EHL Life Sciences Pvt Ltd assumes no responsibility for any
                damages suffered by a user, including, but not limited to, loss
                of data from delays, non-deliveries of content or email, errors,
                system down time, mis-deliveries of content or email, network or
                system outages, file corruption, or service interruptions caused
                by the negligence of EHL Life Sciences Pvt Ltd, its affiliates,
                its licensors, or a user’s own errors and/or omissions except as
                specifically provided herein, EHL Life Sciences Pvt Ltd
                disclaims any warranty or representation that confidentiality of
                information transmitted through the Site will be maintained. No
                advice or information, whether oral or written, obtained by you
                from EHL Life Sciences Pvt Ltd or through the Site shall create
                any warranty not expressly stated in writing. Some states do not
                allow the limitation or exclusion of certain warranties or
                conditions, so some of the above exclusions may not apply to
                you.
              </li>
              <li>
                EHL Life Sciences Pvt Ltd website is designed for
                non-commercial, personal use and you must not use, copy,
                translate, publish, licence or sell any materials or information
                in any other way without our consent, except as permitted under
                applicable law. You must not use EHL Life Sciences Pvt Ltd
                website or the structure, overall style and program code without
                our consent.
              </li>
              <li>
                This agreement is governed by the laws of India. You hereby
                consent to the exclusive jurisdiction of the Courts of Bangalore
                in all disputes arising out of or relating to the use of this
                website.
              </li>
              <li>
                The opinion shared by our doctors is based on the medical
                reports and details provided by the patient at our associated
                hospital / clinic, and the final treatment plan will be based on
                our doctor's personal assessment of the patient at the hospital.
              </li>
              <li>
                The suggested treatment is based on the information and reports
                provided to us. The actual line of treatment may vary based on
                the assessment carried by the consultant once the patient is at
                the hospital
              </li>
              <li>
                The prices quoted are only indicative and can be confirmed only
                after the patient is personally assessed by a doctor at our
                hospital.
              </li>
              <li>
                All international patients are required to produce their
                passport at the registration counter to get registered at the
                hospital as per the directives from Government of India and
                required to register their arrival within 14 days with the
                Foreigners Regional Registration Office (FRRO).
              </li>
            </ul>
          </div>
          <div className="fisherman-content">
            <h3>Limitation of Liability</h3>

            <ul>
              <li>
                EHL Life Sciences Pvt Ltd or its parents, subsidiaries,
                affiliates, officers, directors, employees, agents, or suppliers
                expressly disclaims any and all warranties, express or implied,
                including, without limitation without limiting the foregoing,
                Cauvery Hospital shall not be liable to you or your business for
                any incidental, consequential, special, or punitive damages or
                lost or imputed profits or royalties arising out of this
                agreement or any content contained on the Site, or resulting
                from unauthorized access to or alteration of your transmissions
                or data, or other information that is sent or received or not
                sent or received or in connection with the use of or the
                inability to use this Site or any goods or services provided,
                whether for breach of warranty or any obligation arising there
                from or otherwise, whether liability is asserted in contract or
                tort (including negligence and strict product liability) and
                irrespective of whether you have been advised of the possibility
                of any such loss or damage. Each party hereby waives any claims
                that these exclusions deprive such party of an adequate remedy.
              </li>
            </ul>
          </div>
          <div className="fisherman-content">
            <h3>Indemnification</h3>
            <ul>
              <li>
                You agree to indemnify and hold the EHL Life Sciences Pvt Ltd
                and the officers, agents, employees, partners, and licensors
                harmless from any claim or demand, including reasonable
                attorneys’ fees, made by any third party due to or arising out
                of your use of the Site.
              </li>
            </ul>
          </div>

          <div className="fisherman-content">
            <h3>Feedback &amp; Opinion</h3>
            <ul>
              <li>
                Any feedback/opinion (s) expressed in response to e-mail queries
                shall not be treated as medical advice until and unless the
                physical examination of the patient is carried out no treatment
                shall be initiated. E-mail transmission cannot be guaranteed to
                be secure or error-free as information could be intercepted,
                corrupted, lost, destroyed, arrive late or incomplete, or
                contain viruses. The sender, therefore, does not accept
                liability for any errors or omissions in the contents of this
                message, which arise as a result of e-mail transmission. Whilst
                every effort is made to address all queries and to accommodate
                valuable feedback from the Users, EHL Life Sciences Pvt Ltds
                does not guarantee a response or action to every mail.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsOfUse;
